var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNextPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "12px",
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-Contacts",
    transform: "translate(-836.000000, -673.000000)",
    fill: "#8499C2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(597.000000, 670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-next-page",
    transform: "translate(243.000000, 9.000000) scale(-1, 1) translate(-243.000000, -9.000000) translate(239.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    transform: "translate(4.000000, 4.000000) rotate(45.000000) translate(-4.000000, -4.000000) ",
    x: 3,
    y: 0,
    width: 2,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    transform: "translate(4.000000, 8.235535) rotate(45.000000) translate(-4.000000, -8.235535) ",
    x: 0,
    y: 7.23553467,
    width: 8,
    height: 2,
    rx: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextPage);
export default __webpack_public_path__ + "static/media/icon-next-page.982608f490b7bfcd61b8ed5bb7646d51.svg";
export { ForwardRef as ReactComponent };